<template lang="pug">
.v-navigation-links.navigation-links(v-if="items")
	a.navigation-links__item(v-for="item in items" :href="item.link" :class="{active: item.active}" @click="$emit('model-value', item)")
		| {{item.text}}
		v-sticker.navigation-links__sticker(v-if="item.sticker" :data="item.sticker")
		v-svg-icon.navigation-links__item-icon(icon="arrow-right" v-if="!withoutIcon")

</template>

<script>

export default {

	props: {
		items: {
			type: Array,
			default: null
		},

		withoutIcon: {
			type: Boolean,
			default: false
		},

		isSelected: {
			type: Boolean,
			default: false
		},
	},

	emits: ['model-value'],
}

</script>